// Extracted from shipment-details/tracking-updates/useTrackingUpdates.ts so
// the heat map's per-shipment resolution can reuse the exact same
// leg-scanning logic instead of duplicating it. Given an already-fetched
// order (getOrderDetails), returns the transportIds whose legs actually
// carry a pickup/delivery for this shipment.
export function resolveShipmentTransportIds(
  order: any,
  shipmentNumber: string
): string[] {
  const transports = order?.scheduledRoute?.transports ?? [];

  const matching = transports.filter((transport: any) =>
    Object.values(transport?.legs ?? {}).some((leg: any) => {
      const fromMatch =
        leg?.from?.pickups?.some(
          (p: any) => p?.shipmentNumber === shipmentNumber
        ) ||
        leg?.from?.deliveries?.some(
          (d: any) => d?.shipmentNumber === shipmentNumber
        );
      const toMatch =
        leg?.to?.pickups?.some(
          (p: any) => p?.shipmentNumber === shipmentNumber
        ) ||
        leg?.to?.deliveries?.some(
          (d: any) => d?.shipmentNumber === shipmentNumber
        );
      return fromMatch || toMatch;
    })
  );

  return matching.map((t: any) => t?.transportId).filter(Boolean);
}

export default resolveShipmentTransportIds;
